import { useEffect, useRef, useState } from 'react';
import { usePlotEvents } from '../contexts/plotController/plotControllerContext';
export function useStartMoveEnd(options) {
    const ref = useRef(options);
    useEffect(() => {
        ref.current = options;
    }, [options]);
    const [data, setData] = useState(null);
    usePlotEvents({
        onPointerDown(result) {
            var _a, _b;
            if (result.event.button !== 0 || result.event.altKey)
                return;
            const { coordinates, clampedCoordinates } = result;
            const position = { coordinates, clampedCoordinates };
            setData({ start: position });
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.onStart) === null || _b === void 0 ? void 0 : _b.call(_a, result, position, position);
        },
        onPointerMove(result) {
            var _a, _b;
            // TODO: boolean that says if pointer is currently down?
            if (!data || result.event.altKey)
                return;
            const { coordinates, clampedCoordinates } = result;
            const position = { coordinates, clampedCoordinates };
            setData((data) => {
                if (!data)
                    return null;
                return {
                    ...data,
                    end: position,
                };
            });
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.onMove) === null || _b === void 0 ? void 0 : _b.call(_a, result, data.start, position);
        },
        onPointerUp(result) {
            var _a, _b;
            if (result.event.button !== 0 || !data || result.event.altKey)
                return;
            setData(null);
            if (data.end) {
                (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.onEnd) === null || _b === void 0 ? void 0 : _b.call(_a, result, data.start, data.end);
            }
        },
    }, options);
    return data;
}
//# sourceMappingURL=useStartMoveEnd.js.map